module.exports = __webpack_public_path__ + "img/device_cover_b.19526f1d.svg";